import { Directive } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { filter, map, Observable, shareReplay, switchMap, tap } from 'rxjs';
import { AdditionalPageDto } from 'src/app/api/v1/models';
import { AdditionalPagesRepository } from 'src/app/shared/repositories/additional-pages.repository';

@Directive()
export abstract class TextPageAbstract {

  isLoading$: Observable<boolean> = this.additionalPages.additionalPageLoading$;
  data$: Observable<AdditionalPageDto | null> = this.route.params.pipe(
    switchMap((routeData: Data) => this.additionalPages.getPageShortBySlug(routeData['slug'])),
    tap(shortPage => {
      if (shortPage) { return }
      void this.router.navigate(['page-not-found']);
    }),
    filter((shortPage): shortPage is AdditionalPageDto => !!shortPage),
    switchMap(shortPage => this.additionalPages.getAdditionalPageById(shortPage.id, shortPage.menuLabel)),
    map(page => ({ ...page, content: page.content.replaceAll('{URL}', window.location.origin) })),
    shareReplay({ refCount: true, bufferSize: 1 })
  )

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private additionalPages: AdditionalPagesRepository,
  ) { }
}
